import React, { useState } from 'react';
import Dialog from 'epn-ui/umd/dist/components/Dialog';
import Input from 'epn-ui/umd/dist/components/InputText';

import { toast } from 'react-toastify';
import { faCopy } from '@fortawesome/pro-regular-svg-icons/faCopy';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useI18n from '@i18n';
import copyTextToClipboard from '@utils/clipboard';

import BaseToast from '@base/BaseToast';

import { IGetCreativesDataFormatted } from '@api/types';

import { VALID_SUB } from '../../config';

export interface IModalBannerCodeProps {
    data: IGetCreativesDataFormatted;
    onClose: () => void;
}

const ModalBannerCode: React.FC<IModalBannerCodeProps> = ({ data: { code }, onClose }) => {
    const { t } = useI18n('Creatives');
    const { t: tCommon } = useI18n('Common');
    const { t: tTools } = useI18n('Tools');
    const [sub, setSub] = useState('');
    const [error, setError] = useState('');
    const [bannerCode, setBannerCode] = useState(code);

    const changeSub = value => {
        setError('');

        if (!VALID_SUB.test(value)) {
            setError('Sub may only contain the following symbols');
        } else {
            setBannerCode(value ? code.replace(/src="(.*?)"/, `src="$1?sub=${value}"`) : code);
        }

        setSub(value);
    };

    const onCopyMessage = async bannerCodeParam => {
        await copyTextToClipboard(bannerCodeParam);
        toast.success(<BaseToast text={tCommon('Copied')} type="success" />, {
            toastId: code,
        });
    };

    return (
        <Dialog title={t('Get code smart-banner')} onCancel={onClose} open>
            <Input
                value={bannerCode}
                readOnly
                prefix={<FontAwesomeIcon icon={faCopy} onClick={() => onCopyMessage(bannerCode)} />}
                placeholder={t('Code to insert on website')}
            />
            <div className="mt-6 mb-1">
                <Input
                    value={sub}
                    placeholder={t('Sub (optional)')}
                    onChange={e => changeSub(e.target.value)}
                />
            </div>
            <div className="flex justify-between text-p3 text-blueGray-500">
                <span>{t('Additional method for identifying traffic flow')}</span>
                <span>{sub.length}/50</span>
            </div>
            <p className="text-red-500 text-p3">{tTools(error)}</p>
        </Dialog>
    );
};

export default ModalBannerCode;
